import {
  createVoucher,
  getVoucher,
  getVouchers,
  getVouchersBalance,
} from '@/common/integrations/menhir/employee/vouchers/vouchers.service';
import {
  ICreateVoucherRequestParams,
  IVoucher,
  IVoucherBalance,
  VoucherType,
} from '@/common/integrations/menhir/employee/vouchers/vouchers.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

export const useCreateVoucher = (
  options?: UseMutationOptions<IVoucher, unknown, ICreateVoucherRequestParams>
) => {
  return useMutation({
    mutationFn: createVoucher,
    ...options,
  });
};

export const useGetVouchersBalance = (
  type?: VoucherType,
  options?: UseQueryOptions<IVoucherBalance>
) => {
  const { data: vouchersBalance, ...rest } = useQuery<IVoucherBalance>({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.BALANCE],
    queryFn: () => getVouchersBalance(type),
    ...options,
  });
  return { vouchersBalance, ...rest };
};

export const useGetVouchers = (
  type: VoucherType,
  options?: UseQueryOptions<IVoucher[], any>
) => {
  const { data: vouchers, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.ROOT, type],
    queryFn: () => getVouchers({ type }),
    ...options,
  });

  return { vouchers, ...rest };
};

export const useGetVoucher = (
  { type, voucherId }: { type: VoucherType; voucherId: string },
  options?: UseQueryOptions<IVoucher, any>
) => {
  const { data: voucher, ...rest } = useQuery<IVoucher>({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.DETAIL, type, voucherId],
    queryFn: () => getVoucher(type, voucherId),
    ...options,
  });

  return { voucher, ...rest };
};
